import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

export default function CompareDataChart({ totalAlertSeries, xaxisCategoriesModules }) {
    const [categoriess, setCategories] = useState([])
    const [totalAlertSeriess, setTotalAlertSeries] = useState([])
    console.log({
        "categoriess": categoriess
    }, {
        "totalAlertSeriess": totalAlertSeriess
    }
    )

    useEffect(() => {
        if (totalAlertSeries?.length > 0) {

            setTotalAlertSeries(totalAlertSeries)
        }
    }, [totalAlertSeries])
    useEffect(() => {
        if (xaxisCategoriesModules?.length > 0) {
            setCategories(xaxisCategoriesModules)
        }
    }, [xaxisCategoriesModules])


    const series = [
        {
            name: 'Total Alerts ',
            data: totalAlertSeriess// Previous Week, Current Week
        }
    ]


    const options = {
        chart: {
            type: 'bar',
            height: 350,
            stacked: false,
            toolbar: {
                show: false,
                tools: {
                    download: true,
                    selection: true,
                    zoom: true,
                    zoomin: true,
                    zoomout: true,
                    pan: true,
                    reset: true,
                },
            },
            zoom: {
                enabled: false,
            },
        },
        toolbar: {
            show: false
        },
        colors: ['#0b76b7', '#41b2ef'],
        // colors: ['#ef4343', '#40a1ff'],  // Yellow for Medium Severity

        dataLabels: {
            enabled: true,  // Enable data labels
            style: {
                colors: ['#ffffff'],  // Label color
                fontSize: '11px',  // Adjust font size
            },
            formatter: function (val, opts) {
                return `${val}`; // Show data value in labels
            },
            textAnchor: 'middle',
        },
        tooltip: {
            enabled: true,
            shared: true,  // Tooltip is shared across all series (columns)
            intersect: false,  // Show tooltip only on hover
            style: {
                fontSize: '12px',  // Tooltip text size
                fontWeight: 'normal',
            },
            x: {
                show: true,  // Show category name
                formatter: function (value) {
                    return `${value}`;  // Return category name
                },
            },
            y: {
                formatter: function (value, opts) {
                    // Get the data for the current category (across all series)
                    const seriesValues = opts.w.globals.series;
                    const categoryIndex = opts.dataPointIndex;  // Index for the current category
                    const isAllZero = seriesValues.every(series => series[categoryIndex] === 0 || series[categoryIndex] === null); // Check if all values for this category are 0 or null

                    // If all values are zero/null for this category, return 0%
                    if (isAllZero) {
                        return '0';  // Return 0% when all values for this category are zero or null
                    }
                    else {
                        // If the value is non-zero, show the value as percentage
                        if (value !== 0 && value !== null) {
                            return `${value}`;  // Format and return the value as percentage
                        }
                    }


                }
            }


        },
        plotOptions: {
            bar: {
                horizontal: false,
                borderRadiusWhenStacked: 'all',
                columnWidth: '65%',
                distributed: false,  // Ensures each bar gets its assigned color
                borderRadiusApplication: 'around',
                borderRadius: 4,
                distributed: true // 🎯 This gives each bar a different color


            },
        },
        xaxis: {
            categories: categoriess,
            labels: {
                style: {
                    fontSize: '12px',  // Label font size
                },
                rotate: 0,
                hideOverlappingLabels: false,
                trim: true,  // Trim labels if they are too long
            },
        },
        yaxis: {
            title: {
                text: 'Alerts',
                style: {
                    lineHeight: '2.5',
                    fontSize: '13px',
                    fontWeight: '100',
                    fontFamily: 'sans-serif',
                },

            },
            labels: {
                style: {
                    fontSize: '12px',
                },
            },
            min: 0,
            forceNiceScale: true,
        },
        title: {
            text: 'Summary of Alerts ',
            align: 'center',
            style: {
                fontSize: '14px',
                fontWeight: '500',
            },
        },
        fill: {
            opacity: 1,
        },
        legend: {
            show: true,
            position: 'bottom',  // Position the legend at the bottom
            horizontalAlign: 'center',
            labels: {
                useSeriesColors: false,  // Use the series colors
            },
            markers: {
                width: 12,
                height: 12,
                radius: 12,  // Circular markers for legend
            },
        },
        responsive: [
            {
                breakpoint: 1367,
                options: {
                    chart: {
                        width: '100%',
                        height: 350
                    },
                    xaxis: {
                        labels: {
                            style: {
                                fontSize: '12px',  // Adjust font size for smaller screens
                            },
                            rotate: -45,  // Rotate labels for better fit
                        },
                    },
                }
            },
            {
                breakpoint: 992,
                options: {
                    chart: {
                        height: 350,
                    },
                }
            },
            {
                breakpoint: 697,
                options: {
                    chart: {
                        width: '100%',
                        height: 350
                    },
                    xaxis: {
                        labels: {
                            style: {
                                fontSize: '12px',  // Adjust font size for smaller screens
                            },
                            rotate: -45,  // Rotate labels for better fit
                        },
                    },
                }
            },
            {
                breakpoint: 620,
                options: {
                    chart: {
                        width: '100%',
                    },
                    xaxis: {
                        labels: {
                            style: {
                                fontSize: '10px',  // Adjust font size for smaller screens
                            },
                            rotate: -45,  // Rotate labels for better fit
                        },
                    },
                    dataLabels: {
                        style: {
                            fontSize: '9px',  // Adjust font size for readability
                        },
                    },
                }
            }
        ]
    };




    return (
        <>
            <ReactApexChart
                options={options}
                series={series} // Series based on updated data
                type="bar"
                height={options?.chart?.height}
            />
        </>
    );
}
